import React from 'react';
import {Card, CardText} from 'material-ui/Card';
import { ViewTitle } from 'admin-on-rest/lib/mui';
import HelpIcon from 'material-ui/svg-icons/action/help';

const styles = {
    dash: {flex: {display: 'flex'}},
    dashIcon: {float: 'right', width: 68, height: 68, padding: 16, color: '#757575'},
    card: {borderLeft: 'solid 4px #ff9800', flex: 1, marginBottom: '2em'},
    marginBottom: {marginBottom: '2em'}
};

export default () => (
    <div>
        <Card style={{...styles.dash, ...styles.marginBottom}}>
            <HelpIcon style={styles.dashIcon}/>
            <ViewTitle title="Not Found"/>
            <CardText>
                Sorry, that page was not found.
            </CardText>
        </Card>
    </div>
);


// WEBPACK FOOTER //
// ./src/Fuse/notFound.js